module.exports = __webpack_public_path__ + "media/images/lb/281-164b8643ec287a734573287e1929838e.svg";